/**
 * Created by ivan on 11.04.18.
 */

const MiniGameToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.MINIGAME_BONUS);

    this.countdown = cleverapps.miniGame.countdown;

    cleverapps.miniGame.changeLockedListener = this.changeLocked.bind(this);

    this.changeLocked();
};

MiniGameToolbarItem.prototype = Object.create(ToolbarItem.prototype);
MiniGameToolbarItem.prototype.constructor = MiniGameToolbarItem;

MiniGameToolbarItem.prototype.isVisible = function () {
    if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation) {
        return false;
    }

    return levels.user.checkAvailable(cleverapps.config.availables.MINIGAME);
};

MiniGameToolbarItem.prototype.unlock = function () {
    this.mark();
};

MiniGameToolbarItem.prototype.changeLocked = function () {
    if (cleverapps.miniGame.locked) {
        this.disable();
    } else {
        this.enable();
        this.mark();
    }
};

MiniGameToolbarItem.prototype.onClick = function () {
    if (cleverapps.miniGame.locked) {
        cleverapps.notification.create(Messages.get("MiniGame.ClosedText"), {
            image: this.icon
        });
        return;
    }

    this.unmark();

    cleverapps.focusManager.display({
        focus: "MiniGameWindowFromToolbar",
        action: function (f) {
            cleverapps.focusManager.onceNoWindowsListener = f;
            const reward = cleverapps.clone(cleverapps.miniGame.getReward(), true);
            new MiniGameWindow(reward);
        }
    });
};